export default {
    /**
     * 应用通用显示处理
     * @param param1 显示文本 
     * @param param2 多语言对象
     */
    appcommonhandle:function(param1:any,param2:any){
        return param1;
    }
}